/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import SystemApiClient from "../Api/SystemApiClient";

export default class SystemClient extends SystemApiClient {
    public constructor() {
        super("system");
    }

    public ermittleAppOptions(): Promise<Response> {
        return this.get("ermittleappoptions");
    }

    public async istAngemeldet(): Promise<boolean> {
        const response = await this.get("istangemeldet");
        return response && response.ok && (await response.text() === "true");
    }
}
